import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";
import { emptyState } from "@web/theme/theme";
import { Text } from "./Text";

export type EmptyStateProps = { icon?: LucideIcon; title: ReactNode; body?: ReactNode; action?: ReactNode; className?: string };

export function EmptyState({ icon: Icon, title, body, action, className = "" }: EmptyStateProps) {
  return (
    <div className={`${emptyState.base} ${className}`.trim()}>
      {Icon && <Icon aria-hidden size={40} strokeWidth={1.5} className={emptyState.icon} />}
      <Text variant="headline" align="center">
        {title}
      </Text>
      {body && (
        <Text variant="callout" tone="secondary" align="center">
          {body}
        </Text>
      )}
      {action}
    </div>
  );
}
